import { render } from "./sideMenuRequests.vue?vue&type=template&id=62e16eb3&scoped=true"
import script from "./sideMenuRequests.vue?vue&type=script&lang=js"
export * from "./sideMenuRequests.vue?vue&type=script&lang=js"

import "./sideMenuRequests.vue?vue&type=style&index=0&id=62e16eb3&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62e16eb3"]])

export default __exports__